import React from "react";
import TocTocHeader from "@/components/TocTocHeader";
import TocTocServices from "@/components/TocTocServices";
import TocTocDifferentials from "@/components/TocTocDifferentials";
import TocTocCTA from "@/components/TocTocCTA";
import TocTocFooter from "@/components/TocTocFooter";
import SEOHead from "@/components/common/SEOHead";

const Services = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": ["WebPage", "CollectionPage"],
        "@id": "https://site.toctocbr.com/servicos#webpage",
        "url": "https://site.toctocbr.com/servicos",
        "name": "Serviços de Fotografia Imobiliária | Toc Toc",
        "inLanguage": "pt-BR",
        "isPartOf": { "@id": "https://site.toctocbr.com/#website" },
        "description": "Pacotes de fotografia imobiliária, vídeos, arquitetura e interiores, social media e Airbnb. Entrega em 48h. Veja planos e solicite orçamento."
      },
      {
        "@type": ["Organization", "LocalBusiness", "ProfessionalService"],
        "@id": "https://site.toctocbr.com/#org",
        "name": "Toc Toc",
        "url": "https://site.toctocbr.com/",
        "logo": "https://site.toctocbr.com/logo.png",
        "description": "Fotografia e vídeo imobiliário profissional, arquitetura, interiores e Airbnb em Santa Catarina.",
        "telephone": "+55-47-99736-7396",
        "email": "contato@toctocbr.com",
        "sameAs": [
          "https://www.instagram.com/toctoc.br",
          "https://www.huntercrm.com.br"
        ],
        "areaServed": [
          "Balneário Camboriú",
          "Camboriú",
          "Itajaí",
          "Itapema",
          "Porto Belo",
          "Bombinhas",
          "Santa Catarina",
          "Brasil"
        ]
      },
      {
        "@type": "ItemList",
        "@id": "https://site.toctocbr.com/servicos#catalogo",
        "name": "Catálogo de Serviços Toc Toc",
        "itemListOrder": "http://schema.org/ItemListOrderAscending",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "item": { "@id": "https://site.toctocbr.com/servicos#fotografia-imobiliaria" } },
          { "@type": "ListItem", "position": 2, "item": { "@id": "https://site.toctocbr.com/servicos#videos-imobiliarios" } },
          { "@type": "ListItem", "position": 3, "item": { "@id": "https://site.toctocbr.com/servicos#arquitetura-interiores" } },
          { "@type": "ListItem", "position": 4, "item": { "@id": "https://site.toctocbr.com/servicos#social-media" } },
          { "@type": "ListItem", "position": 5, "item": { "@id": "https://site.toctocbr.com/servicos#airbnb" } }
        ]
      },
      {
        "@type": "Service",
        "@id": "https://site.toctocbr.com/servicos#fotografia-imobiliaria",
        "serviceType": "Fotografia Imobiliária Profissional",
        "provider": { "@id": "https://site.toctocbr.com/#org" },
        "description": "Fotografia imobiliária de alta qualidade para corretores, imobiliárias e construtoras. Edição premium e entrega em 48h.",
        "areaServed": ["SC", "Balneário Camboriú", "Itajaí", "Itapema", "Porto Belo"],
        "offers": { "@type": "Offer", "url": "https://site.toctocbr.com/contato" }
      },
      {
        "@type": "Service",
        "@id": "https://site.toctocbr.com/servicos#videos-imobiliarios",
        "serviceType": "Filmmaker Imobiliário — Vídeos de Imóveis",
        "provider": { "@id": "https://site.toctocbr.com/#org" },
        "description": "Produção e edição de vídeos imobiliários, cortes para redes sociais e tours visuais. Drone incluso sob demanda.",
        "offers": { "@type": "Offer", "url": "https://site.toctocbr.com/contato" }
      },
      {
        "@type": "Service",
        "@id": "https://site.toctocbr.com/servicos#arquitetura-interiores",
        "serviceType": "Fotografia de Arquitetura e Interiores",
        "description": "Ensaio técnico e artístico para arquitetos e designers de interiores, com fidelidade cromática e composição premium.",
        "provider": { "@id": "https://site.toctocbr.com/#org" }
      },
      {
        "@type": "Service",
        "@id": "https://site.toctocbr.com/servicos#social-media",
        "serviceType": "Social Media Imobiliário",
        "description": "Edição de reels, stories e postagens a partir dos ensaios fotográficos e vídeos imobiliários. Ideal para corretores digitais.",
        "provider": { "@id": "https://site.toctocbr.com/#org" }
      },
      {
        "@type": "Service",
        "@id": "https://site.toctocbr.com/servicos#airbnb",
        "serviceType": "Fotografia para Airbnb e Temporada",
        "description": "Fotos profissionais para aumentar reservas no Airbnb e Booking, com foco em iluminação e ambientes instagramáveis.",
        "provider": { "@id": "https://site.toctocbr.com/#org" }
      },
      {
        "@type": "FAQPage",
        "@id": "https://site.toctocbr.com/servicos#faq",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Qual é o prazo de entrega das fotos?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "As fotos são entregues em até 48 horas, editadas e prontas para uso em portais e redes sociais."
            }
          },
          {
            "@type": "Question",
            "name": "Vocês fazem vídeos imobiliários e filmagens com drone?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Sim! Oferecemos vídeos imobiliários, inclusive com drone, e cortes otimizados para redes sociais."
            }
          },
          {
            "@type": "Question",
            "name": "Atendem hospedagens e Airbnb?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Sim. Fotografamos imóveis de temporada para anfitriões em plataformas como Airbnb e Booking."
            }
          },
          {
            "@type": "Question",
            "name": "Vocês atendem quais cidades?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Balneário Camboriú, Camboriú, Itajaí, Itapema, Porto Belo, Bombinhas e região de Santa Catarina."
            }
          },
          {
            "@type": "Question",
            "name": "O que é o CRM da Toc Toc?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Nosso CRM é o Hunter CRM Imobiliário (https://www.huntercrm.com.br), uma plataforma inteligente que auxilia corretores com automação, distribuição de leads e relatórios integrados."
            }
          }
        ]
      }
    ]
  };

  return (
    <>
      <SEOHead
        title="Serviços de Fotografia Imobiliária Profissional"
        description="Fotografia imobiliária, vídeos profissionais, filmmaker, fotografia de arquitetura e interiores e fotos para Airbnb. Entrega em 48h. Atendemos Balneário Camboriú, Camboriú, Itajaí, Itapema, Porto Belo e Bombinhas. Veja os pacotes completos e transforme seus anúncios."
        keywords="fotografia imobiliária, fotógrafo imobiliário, fotógrafo de arquitetura, filmmaker imobiliário, vídeos imobiliários, fotografia de interiores, fotografia para Airbnb, fotos para anfitrião, Balneário Camboriú, Itajaí, Itapema, Porto Belo, Bombinhas, Camboriú, Santa Catarina, fotógrafo de imóveis, pacote de fotografia imobiliária, fotografia profissional de imóveis, vídeos de imóveis, social media imobiliário"
        canonicalUrl="/servicos"
        ogImage="https://site.toctocbr.com/og-servicos.jpg"
        ogImageAlt="Toc Toc — fotografia imobiliária profissional em SC"
        ogTitle="Serviços de Fotografia Imobiliária | Toc Toc"
        ogDescription="Fotografia e vídeos imobiliários, filmmaker, arquitetura e interiores, Airbnb e social media. Entrega em 48h. Veja os planos."
        twitterTitle="Toc Toc Fotografia Imobiliária Profissional"
        twitterDescription="Fotografia e vídeos imobiliários, filmmaker e Airbnb. Conheça nossos serviços."
        schema={jsonLd}
        prefetchLinks={["/portfolio", "/sobre", "/cidades-atendidas", "/contato"]}
        titleTemplate={null}
      />

      <div className="min-h-screen bg-white">
        <TocTocHeader />
        <main id="conteudo-principal" role="main">
          <TocTocServices />
          <TocTocDifferentials />
          <TocTocCTA />
        </main>
        <TocTocFooter />
      </div>
    </>
  );
};

export default Services;

